import React from 'react';
import { Card } from 'antd';
import { CardProps as CardCopyProps } from 'antd/lib/card';

export type CardProps = CardCopyProps;

const ProCard: React.FC<CardProps> = (props) => {
  const { children, ...resProps } = props;
  return <Card {...resProps}>{children}</Card>;
};

export default ProCard;
